import { ServizioDto } from "@api/client";
import { createReducer } from "@reduxjs/toolkit";
import { serviceGetService, serviceUpdateService } from "./actions";

export interface ServiceReducerType {
	service: ServizioDto | undefined;
}

const initialState: ServiceReducerType = {
	service: undefined,
};

export const serviceReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(serviceGetService.fulfilled, (state, action) => {
			state.service = action.payload;
		})
		.addCase(serviceUpdateService.fulfilled, (state, action) => {
			state.service = action.payload;
		});
});
